import * as React from "react";
import { UncontrolledPopover, PopoverHeader, PopoverBody, Row, Col } from "reactstrap";
import { Reservation, ReservationStatus, EntityChange, EntityChangeAction } from "../../../store/reservations/ReservationEntities";
import { AgentRole } from "../../../store/agents/AgentEntities";
import { KeyDesc } from "../../../store/shared/KeyDesc";
import { List } from '../../base/list';
import _ from "underscore";
import moment from "moment";

export interface ChangeListPropos {
    reservation?: Reservation
}

export class ReservationChangeLog extends React.Component<ChangeListPropos>{

    constructor(props) {
        super(props);
    }

    resolveAction(action: EntityChangeAction): string {
        switch (action) {
            case EntityChangeAction.AskReview:
                return "Richiesta revisione";
            case EntityChangeAction.Created:
                return "Creata"
            case EntityChangeAction.Modified:
                return "Ultima Modifica";
            case EntityChangeAction.Reviewed:
                return "Revisionata";
            default:
                return "";
        }
    }

    getChangesList(): JSX.Element {

        if (!this.props.reservation?.changes) {
            return (<React.Fragment>
            </React.Fragment>);
        }

        let rservationChangesList = this.props.reservation?.changes.map(change => {
            return (<li className="text-eurorounders">{`${this.resolveAction(change.action)} il: ${moment(change.eventDate).format("L")} ${moment(change.eventDate).format("LT")} da: ${change.performedByFullName}`}</li>)
        });

        return (<React.Fragment>{rservationChangesList}</React.Fragment>);

    }

    render() {

        if (typeof this.props.reservation === "undefined" ||
            this.props.reservation == null ||
            typeof this.props.reservation.changes === "undefined" ||
            this.props.reservation.changes == null ||
            this.props.reservation.changes.length == 0) {
            return (<React.Fragment>
            </React.Fragment>);
        }
        return (<React.Fragment>
            <h4 className="text-eurorounders">Modifiche Rilevanti:</h4>
            <ul className="text-eurorounders">{this.getChangesList()}</ul>
        </React.Fragment>)


    }

}